module.exports = __webpack_public_path__ + "img/card-profile5-square.c6d2a432.jpg";